<template>
  <v-container class="feed">
    <v-list>
      <v-row
          align="center"
          justify="center"
          class="pb-4 pl-8 pr-8">
          <h4 class="display-1 font-weight-light text-center">
            Your daily top picks from your saved creatives - enjoy
          </h4>
      </v-row>
      <v-row
          align="center"
          justify="center"
          class="pb-8"
          v-if="appState.images.length === 0">
          <h4 class="subtitle font-weight-regular text-center">
            Tap the + to add your first creative person.
          </h4>
      </v-row>


      <template v-for="(item) in appState.images">
        <v-list-item
          :key="item.id"
          :to="'/image/' + item.id"
          style="padding: 0px;">

        <ImagePreview :imageItem="item"/>

        </v-list-item>
      </template>

      <v-row
        align="center"
        justify="center"
        class="pt-4 pl-8 pr-8"
        v-if="appState.images.length !== 0">
          <h4 class="display-1 font-weight-light text-center">
            ...hungry for more?
          </h4>
      </v-row>
      <v-row
          align="center"
          justify="center"
          class="pb-12"
          v-if="appState.images.length !== 0">
          <v-col cols='9'>
            <h4 class="subtitle font-weight-regular text-center">
              Every day, we show you 15 new hot picks from your saved creatives. The more creatives you add, the more exciting your daily picks!
            </h4>
          </v-col>
      </v-row>
    </v-list>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import ImagePreview from '@/components/ImagePreview.vue'

export default {
  name: 'Feed',
  data() {
    return {
      appState: this.$root.$data.appStore.state,
      analytics: this.$root.$data.analytics,
    }
  },
  components: {
    ImagePreview,
  }
}
</script>
